import { useDispatch, useSelector } from 'react-redux';
import ForgotPassword from './ForgotPassword';
import { userForgotDetailsActionV2 } from '../../../store/actions/UserActions';
import { useEffect, useRef, useState } from 'react';
import { isValidMobileNotEmpty, isValidEmailNotEmpty } from '../../../../../constants/Validators';
import {config, service} from '../../../../needHelp/utils';

export function useForgotPasswordContainer(props) {
  const dispatch = useDispatch();
  const { user: { forgotDetails, userStatus } } = useSelector((state: any) => {
    return state;
  });
  const timerRef = useRef(null);
  const [ showModal, setShowModal ] = useState(props.showModal || false);
  const [ mobileNumber, setMobileNumber ] = useState('');
  const [ email, setEmailId ] = useState('');
  const [ error, setError ] = useState('');
  const [ rotate, setRotate ] = useState(false);
  const [ validationFail, setValidationFail ] = useState(false);
  const [ disabled, setDisabled ] = useState(true);
  const [ validationErrorMessage, setValidationErrorMessage ] = useState('');

  useEffect(() => {
    if (rotate) {
      goToPasswordRetrievalPages(forgotDetails);
    }
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [ forgotDetails ]);

  const goToPasswordRetrievalPages=(forgotDetails) => {
    const userForgotDetails = { ...forgotDetails,
      mobileEntered: mobileNumber,
      userId: props.userStatus.userId };
    if (forgotDetails.error) {
      if (props.isStandAlone) {
        setRotate(false);
        setValidationFail(true);
        // trim and remove error code sent by backend in the error message.
        setValidationErrorMessage(forgotDetails.error.trim().replace(/[0-9-+]/g, ''));
      } else {
        props.switchModal('getPasswordFailure', userForgotDetails);
      }
    } else if(!props.isStandAlone){
      props.switchModal('getPasswordSuccess', userForgotDetails);
    } else {
      props.switchModal('getPasswordSuccessStandalone', userForgotDetails);
    }
  };
  const userNameVerified = () => {
    props.updateVerifiedUser(props.userStatus.userId);
  };

  const closeModal = () => {
    setShowModal(false);
    props.closeModal();
  };

  const handleInputKeyUpViaParent = (val, field) => {
    if (field && field === "E") {
      handleEmailUpdate(val);
      setMobileNumber('');
    } else {
      setEmailId('');
      handleMobileUpdate(val);
    }
  };

  const handleEmailUpdate = (val) => {
    if (val && val.length > 0) {
      setEmailId(val);
    }
    if (isValidEmailNotEmpty(val)) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }

  const handleMobileUpdate = (val) => {
    if (val && val.length > 0) {
      setMobileNumber(val);
    }
    if (isValidMobileNotEmpty(val)) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const rotateLoader= () => {
    service.trackClick(config.NEED_HELP_TRACKING.NEED_HELP, config.CTA_TRACKING_ID.FORGOT_PASSWORD);
    if (!disabled) {
      setRotate(true);
      const queryParams = {
        mobile: mobileNumber,
        email: email,
        userLoginId: props.userStatus.userId,
        otpType: email ? 'E' : 'M' };

      dispatch(userForgotDetailsActionV2('P', queryParams));
      timerRef.current = setTimeout(() => {
        setRotate(false);
      }, 1500);
    }
  };

  const clearValidationError = () => {
    setValidationFail(false);
    setDisabled(true);
  }
  return {
    state: {
      showModal,
      userStatus,
      forgotDetails,
      mobileNumber,
      error,
      rotate,
      validationFail,
      disabled,
      validationErrorMessage
    },

    action: {
      rotateLoader,
      handleInputKeyUpViaParent,
      closeModal,
      userNameVerified,
      clearValidationError
    },
  };

}
